const EditFillIcon = () => {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="52" height="52" rx="5" fill="#D2D2D2" />
      <path
        style={{filter: "brightness(0)"}}
        d="M17.4444 34.5556H19.1861L31.1333 22.6083L29.3917 20.8667L17.4444 32.8139V34.5556ZM15 37V31.8056L31.1333 15.7028C31.3778 15.4787 31.6479 15.3056 31.9437 15.1833C32.2394 15.0611 32.5499 15 32.875 15C33.2001 15 33.5158 15.0611 33.8222 15.1833C34.1286 15.3056 34.3934 15.4889 34.6167 15.7333L36.2972 17.4444C36.5417 17.6685 36.7201 17.9333 36.8325 18.2389C36.945 18.5444 37.0008 18.85 37 19.1556C37 19.4815 36.9442 19.7923 36.8325 20.0881C36.7209 20.3839 36.5425 20.6536 36.2972 20.8972L20.1944 37H15ZM30.2472 21.7528L29.3917 20.8667L31.1333 22.6083L30.2472 21.7528Z"
        fill="black"
      />
    </svg>
  );
};
export default EditFillIcon;
